module.exports = __webpack_public_path__ + "static/364086_0_0-34bfa66f666cac3afac3961f393f7bfa.woff2";